// UI translations for this locale. Keys must match the es reference bundle —
// enforced by `npm run check:i18n` (scripts/check-i18n-parity.mjs).
export const eu = {
  app: { name: 'bitutravel' },
  nav: {
    home: 'Hasiera',
    search: 'Bilatu',
    login: 'Saioa hasi',
    register: 'Eman izena',
    dashboard: 'Laburpena',
    reservas: 'Erreserbak',
    equipo: 'Taldea',
    logout: 'Saioa itxi',
    legal: 'Legala',
    legalNotice: 'Lege-oharra',
    privacy: 'Pribatutasun-politika',
    cookies: 'Cookie-politika',
    terms: 'Baldintza orokorrak',
    clientes: 'Bezeroak',
  },
  legal: {
    noticeTitle: 'Lege-oharra',
    noticeBody:
      '34/2002 Legea (LSSI-CE) betez, webgune hau bitutravelen jabetzakoa dela jakinarazten da. Harremanetarako posta: legal@bitutravel.app. Gunea erabiltzeak erabiltzaile izatea ematen du eta baldintza hauek onartzea dakar.',
    privacyTitle: 'Pribatutasun-politika',
    privacyBody:
      'Zure datuak zure kontua, erreserbak eta espainiar araudiko fakturazioa kudeatzeko bakarrik prozesatzen ditugu (RGPD eta LOPDGDD). Inoiz ez dizugu zure datuak hirugarrenei ematen helburu komertzialekin. Sarrera, zuzenketa, ezabaketa eta garraiatzeko eskubideak erabiltzeko, idatzi privacy@bitutravel.app helbidera.',
    cookiesTitle: 'Cookie-politika',
    cookiesBody:
      'bitutravel funtsezko cookie teknikoak soilik erabiltzen ditu: autentifikazio-saioa eta hizkuntza-hobespena. Ez dugu publizitate-cookie edo hirugarrenen jarraipen-cookie-rik erabiltzen.',
    termsTitle: 'Baldintza orokorrak',
    termsBody:
      'Erreserbak plataformaren bidez eskatzen dira eta jabearen onarpenaren eta aukeratutako ezeztapen-politikaren mende daude. Enpresen fakturazioa espainiar araudiaren arabera ematen da (BEZ eta IRPF aplikagarriak). bitutravel bitartekari gisa aritzen da eskaera egiten duen enpresaren eta ostatuaren jabearen artean. Bistaratutako prezioek BEZ (%21) ez dute barne; erreserbaren guztizkoari gehitzen zaio.',
  },
  landing: {
    heroTitle: 'Arazorik gabeko enpresa-ostatuak',
    heroSubtitle:
      'Kalitatezko epe ertaineko ostatuak aurkitu zure taldeentzat Espainia osoan. Enpresa aurrelarien konfiantzarekin.',
    checkIn: 'Sarrera',
    checkOut: 'Irteera',
    guests: 'Pertsonak',
    search: 'Bilatu',
    featured: 'Nabarmendutako ostatuak',
    featuredIn: '{{city}}: nabarmendutako ostatuak',
    guestsValue: '{{count}} pertsona',
    where: 'Non',
    when: 'Noiz',
    who: 'Nor',
    searchDestinations: 'Bilatu helmugak',
    addDates: 'Gehitu datak',
    addGuests: 'Gehitu pertsonak',
    howItWorks: 'Nola funtzionatzen du',
    step1Title: 'Bilatu',
    step1Desc: 'Arakatu egiaztatutako ostatuak Espainiako hiri nagusietan.',
    step2Title: 'Erreserbatu',
    step2Desc: 'Erreserbatu epe ertaineko ostatuak zure taldeentzat enpresa-baldintzekin.',
    step3Title: 'Mugitu',
    step3Desc: 'Zure taldea ostatatzen da. Gu kudeatzen dugu faktura eta bidaialariaren gastu-oharra.',
    perNight: '/ gau',
    perNightPlusIva: '/ gaua + BEZ',
    comingSoon: 'Laster',
    trustedBy: 'Jada gurekin konfiantza dute',
    testimonialsTitle: 'Gure bezeroek esandakoa',
    review1Text: 'bitutravel erabiltzen hasi ginenetik fakturak iristen zaizkigu eta prozesu osoa errazten du.',
    review1Author: 'Maria López',
    review1Role: 'Mugikortasuneko arduraduna, kontsulta teknologikoa',
    review2Text: 'Talde osoaren ostatua plataforma bakar batean kudeatzen dugu. Denbora eta kostuen aurrezpena nabaria da.',
    review2Author: 'Javier Ruiz',
    review2Role: 'Operazioen zuzendaria, ingeniaritza-enpresa',
    review3Text: 'Fakturazio korporatiboa eta bidaiariaren txostena auditoriarako prest datoz. Lan administratiborik ez.',
    review3Author: 'Elena García',
    review3Role: 'Finantza-arduraduna, multinazionala',
    illustrativeImage: 'irudi ilustratiboa',
  },
  search: {
    allSpain: 'Espainia osoa',
    allDistricts: 'Barruti guztiak',
    viewAllResults: 'Ikusi emaitza guztiak',
    results: 'emaitza',
    sort: 'Ordenatu',
    sortPriceAsc: 'Prezia: txikitik handira',
    sortPriceDesc: 'Prezia: handitik txikira',
    noResults: 'Ez dago ostaturik eremu honetan.',
    noResultsForFilters: 'Ez dago ostaturik iragazki hauekin. Saiatu datak kentzen edo iragazkiak aldatzen.',
    clearFilters: 'Kendu iragazkiak',
    areaPlaceholder: 'Auzoa, area edo posta-kodea',
    showMap: 'Mapa',
    showMore: 'Ikusi gehiago',
    backToTop: 'Gora',
    typeAll: 'Guztia',
    placeEntire: 'Apartamentu osoa',
    placeRoom: 'Gela',
    placeHotel: 'Hotel',
    dates: 'Datak',
    sortRecommended: 'Gomendatua',
    size: 'Logelak',
    sizeAny: 'Edozein',
    sizeSingle: '1 logela',
    sizeDouble: '2 logela',
    size3plus: '3+ logela',
    rooms: 'Logelak',
    units: 'Unitateak',
    grouping: 'Taldekatu',
    groupAny: 'Edozein',
    typeInCity: '{{type}} · {{city}}',
    forNights: '{{count}} gauetarako',
    filters: 'Iragazkiak',
    groupSameBuilding: 'Eraikin bera',
    groupSameArea: 'Gertuko gunea',
    groupSameCategory: 'Kategoria bera',
    roomsValue: '{{count}} log.',
    unitsValue: '{{count}} u.',
    groupResults: 'talde',
    fromPrice: '{{price}}-tik',
    unitsInBuilding: '{{count}} unitate eraikin honetan',
    groupUnits: 'unitate',
    sameBuilding: 'Eraikin bera',
    sameArea: 'Gertuko gunea',
    sameCategory: 'Kategoria bera',
    anyGroup: 'Unitateak',
    priceFrom: 'tik',
    bookAll: 'Erreserbatu {{count}} guztiak',
    playTour: 'Bira erreproduzitu',
    approxMapNote: 'Kokapenak gutxi gorabeherakoak dira. Eman izena kokapen zehatza ikusteko.',
    pauseTour: 'Bira pausatu',
    bookAllTitle: 'Taldea erreserbatu',
    bookAllDesc: 'Erreserbatu {{count}} unitate guztiak multzo bakar gisa.',
    bookAllSummary: '{{count}} unitate · {{nights}} gau',
    bookAllSomeFailed: 'Unitate batzuk ezin izan dira erreserbatu.',
    bookAllDone: 'Multzoa erreserbatuta ({{ok}}/{{count}}).',
    structRoomIn: 'Gela: {{building}}',
    structRoomsSameApartment: '{{count}} gela apartamentu berean',
    structRoomsSameBuilding: '{{count}} gela eraikin berean',
    structApartmentsSameBuilding: '{{count}} apartamentu eraikin berean',
    structStaysSameArea: '{{count}} ostatu area berean',
    structStaysSameCategory: '{{count}} ostatu · {{category}}',
    structUnits: '{{count}} unitate',
    specFull: '{{guests}} bezero · {{bedrooms}} logela · {{baths}} komun',
    specShort: '{{bedrooms}} log. · {{baths}} komun',
  },
  detail: {
    guests: 'pertsona',
    bedrooms: 'logela',
    bathrooms: 'bainuak',
    amenities: 'Zerbitzuak',
    location: 'Kokapena',
    nights: 'gau',
    cleaningFee: 'Garbiketa',
    total: 'Guztira',
    iva: 'BEZ ({{pct}}%)',
    ivaNote: 'Prezioak BEZ gabe: erreserbaren totalari %21ko BEZ gehitzen zaio. Enpresa-faktura arauemailea.',
    bookNow: 'Erreserbatu orain',
    loginToBook: 'Hasi saioa erreserbatzeko',
    signInForDetails: 'Hasi saioa xehetasun guztiak ikusteko.',
    approxLocation: 'Kokapen gutxi gorabeherakoa (~700 m erradioa)',
    checkin: 'Sarrera',
    checkout: 'Irteera',
    tooManyGuests: 'Jabetza honek gehienez {{capacity}} pertsona hartzen ditu.',
    minStayWarning: 'Gutxieneko egonaldia: {{count}} gau | Gutxieneko egonaldia: {{count}} gau',
    nightsWithCount: '{{count}} gau | {{count}} gau',
  },
  booking: {
    title: 'Erreserbatu orain',
    subtitle: 'Egiaztatu bidaialariaren datuak. Zenbatekoa zerbitzarian birkalkulatzen da.',
    confirm: 'Berretsi erreserba',
    guestName: 'Bidaialariaren izena',
    guestNamePlaceholder: 'Izen-abizenak',
    guestNif: 'Bidaialariaren NIF',
    datesRequired: 'Hautatu baliozko datak',
    nameRequired: 'Sartu bidaialariaren izena',
    nifInvalid: 'NIF baliogabea',
    requestCreated: 'Erreserba sortuta. Ordainketaren zain.',
    notAvailable: 'Data horiek jada ez daude eskuragarri.',
    notApproved: 'Zure kontua ez dago onartuta erreserbatzeko.',
    createError: 'Ezin izan da erreserba sortu. Saiatu berriro.',
    awaitingDesc: 'Erreserba sortuta. Egin ordainketa berresteko.',
    totalWithIva: 'Guztira (BEZ barne)',
    priceEstimateNote: 'Prezio estimatua: bitutravel-ek kalkulatzen du azken zenbatekoa erreserbatzean.',
    total: 'Guztira',
    reference: 'Erreferentzia',
    openPaymentLink: 'Ireki ordainketa-esteka',
    mockDevNote:
      'Garapen modua: ordainketa simulatua da. Sakatu ordainduta markatzeko eta Revolut webhook-a simulatzeko.',
    markPaidDev: 'Markatu ordainduta (dev)',
    markPaidError: 'Ezin izan da ordainketa simulatu.',
    paid: 'Ordainketa berretsi da',
    paidDesc: 'Zure erreserba berretsi da. Faktura posta bidez jasoko duzu.',
    viewBookings: 'Ikusi nire erreserbak',
    paymentStatus: 'Ordainketa',
    bookingsTitle: 'Nire erreserbak',
    browseStays: 'Bilatu ostatua',
    summaryTotal: 'Erreserbak',
    summaryUpcoming: 'Hurrengoak',
    summaryInstay: 'Egonaldian',
    summarySpend: 'Gastu totala',
    summaryPendingNote: '{{count}} erreserba ordainketa zain.',
    payStatusPaid: 'Ordainduta',
    payStatusPending: 'Zain',
    payStatusAwaiting: 'Ordainketa zain',
    payStatusRefunded: 'Itzulita',
    payStatusFailed: 'Huts egin du',
    payStatusScheduled: 'Programatuta',
    empty: 'Oraindik ez duzu erreserbarik.',
    statusAwaitingPayment: 'Ordainketaren zain',
    statusConfirmed: 'Berretsita',
    statusActive: 'Abian',
    statusCompleted: 'Osatuta',
    statusCancelled: 'Ezeztatuta',
    statusDisputed: 'Gatazkan',
    notFound: 'Erreserba ez da aurkitu.',
    viewProperty: 'Ikusi jabetza',
    cleaningFee: 'Garbiketa',
    platformFee: 'bitutravel komisioa',
    cancelBooking: 'Ezeztatu erreserba',
    cancelConfirm: 'Ziur erreserba hau ezeztatu nahi duzula? Ekintza hau ezin da desegin.',
    cancelConfirmYes: 'Bai, ezeztatu',
    cancelledToast: 'Erreserba ezeztatu da.',
    cancelError: 'Ezin izan da erreserba ezeztatu.',
    cancelReason: 'Ezeztapenaren arrazoia',
    copyLink: 'Kopiatu esteka',
    tabFuture: 'Hurrengoak',
    tabPresent: 'Abian',
    tabPast: 'Iraganak',
    emptyTab: 'Ez dago erreserbarik atal honetan.',
    purpose: 'Bidaiaren arrazoia',
    purposeLeisure: 'Pertsonala',
    purposeConference: 'Biltzarra / ekitaldia',
    purposeProject: 'Proiektua',
    purposeRelocation: 'Berkokapena',
    purposeOther: 'Beste bat',
    eventName: 'Ekitaldiaren izena',
    eventNamePlaceholder: 'Adib. Mobile World Congress 2026',
    teamSize: 'Pertsonak',
    teamNotes: 'Taldearen xehetasunak',
    teamNotesPlaceholder: 'Bidaiarien izenak, gela, oharrak…',
    teamDetails: 'Bidaiaren / taldearen xehetasunak',
    employee: 'Langilea',
    employeePlaceholder: 'Esleitu gabe',
    employeeNone: 'Langilerik gabe',
    employeeFilterAll: 'Langile guztiak',
    employeeCardTitle: 'Esleitutako langilea',
  },
  team: {
    title: 'Taldea',
    addEmployee: 'Gehitu langilea',
    intro: 'Kudeatu enpresako langileak. Esleitu erreserbei xehetasunak emailed jasoko dituzten, edo aktibatu euren erreserbak enpresaren kontura egiteko.',
    featureRosterTitle: 'Langileen zerrenda',
    featureRosterDesc: 'Langile bakoitzaren izena, emaila, telefonoa eta NIF. Gehienak errepikariak dira: erreserbetan berrerabilgarri.',
    featureEmailTitle: 'Xehetasunak emailed',
    featureEmailDesc: 'Erreserbatzean, esleitu langilea eta ostatuaren datuak emailed jasoko ditu.',
    featureActivateTitle: 'Aktibatu erreserbatzeko',
    featureActivateDesc: 'Aktibatu langile bat bere emailarekin sartu eta enpresaren izenean erreserba dezan.',
    empty: 'Oraindik ez dago langilerik. Laster gehitu ahal izango dituzu eta erreserbei esleitu.',
    editEmployee: 'Editatu langilea',
    editDesc: 'Aldatu langilearen kontaktu-datuak.',
    addDesc: 'Gehitu langile bat eta aktibatu bere emailarekin sartzeko.',
    addNote: 'Langilea fitxan gehituko da. Bere korreoelektronikoarekin sartzeko, aktiba ezazu bere sarbidea gero.',
    activateLogin: 'Sarbidea aktibatu',
    alreadyActivated: 'Langile horrek badu sarbidea aktibatuta.',
    platformUnavailable: 'Zerbitzua ez dago erabilgarri orain. Saiatu geroago.',
    phone: 'Telefonoa',
    updated: 'Langilea eguneratuta.',
    added: 'Langilea gehituta.',
    emailExists: 'Badago email hori duen langile bat.',
    activated: 'Langilea aktibatuta.',
    deactivated: 'Langilea desaktibatuta.',
    deleted: 'Langilea ezabatuta.',
    activate: 'Aktibatu',
    deactivate: 'Desaktibatu',
    delete: 'Ezabatu',
    deleteTitle: 'Ezabatu langilea',
    deleteConfirm: 'Ziur {{name}} ezabatu nahi duzula? Bere kontua ezabatuko da eta ezin izango da desegin.',
    statusActive: 'Aktibo',
    statusInactive: 'Inaktibo',
    statusRoster: 'Fitzatik soilik',
    tempPwTitle: 'Aldi baterako pasahitza',
    tempPwDesc: 'Hau da {{name}}(r)en aldi baterako pasahitza. Partekatu ezazu modu seguruan.',
    tempPwWarn: 'Ez da berriro erakutsiko. Kopiatu orain.',
    copy: 'Kopiatu',
    copied: 'Kopiatuta',
  },
  agency: {
    title: 'Bezeroak',
    intro: 'Kudeatu zure agentziaren bezero-enpresak. Gehitu itzazu fakturazio-emailarekin eta egin erreserbak haien izenean: faktura bezero-enpresari joaten zaio.',
    addClient: 'Gehitu bezero-enpresa',
    clientEmail: 'Enpresaren fakturazio-emaila',
    clientEmailPlaceholder: 'fakturak@enpresa.eus',
    addNote: 'Enpresak bitutravel-en kontua eduki eta onartuta egon behar du. Estekatzean balioztatuko da.',
    empty: 'Ez duzu bezero-enpresarik oraindik. Gehitu batzuk haien izenean erreserbatzen hasteko.',
    client: 'Bezeroa',
    unknownClient: 'Bezero-enpresa',
    unlinkConfirm: 'Ziur {{name}} desestekatu nahi duzula? Ezin izango duzu haien izenean erreserbatu.',
    unlinkedBtn: 'Desestekatu',
    unlinked: 'Bezero-enpresa desestekatuta.',
    linked: 'Bezero-enpresa estekatuta: {{name}}.',
    notFound: 'Ez da email hori duen onartutako enpresarik aurkitu.',
    billTo: 'Erreserbatu honentzat',
    selectClient: 'Hautatu bezero-enpresa bat',
    noClientsWarn: 'Gehitu lehenengo bezero-enpresa bat Bezeroak atalean erreserbatu ahal izateko.',
  },

  invoices: {
    title: 'Fakturak eta gastu-oharrak',
    backToBookings: '← Nire erreserbak',
    count: 'Fakturak',
    baseTotal: 'Zerga-oinarria',
    ivaTotal: 'BEZ',
    irpfTotal: 'IRPF atxikipena',
    total: 'Fakturatutako guztizkoa',
    invoicesTitle: 'Fakturak',
    ref: 'Erreserba',
    parteTitle: 'Bidaialarien gastu-oharrak',
    parteEmpty: 'Oraindik ez dago gastu-oharrarik.',
    empty: 'Oraindik ez duzu fakturarik. Erreserba bat berrestean sortzen dira automatikoki.',
    regenTitle: 'Berrargitaratu dokumentuak',
    regenDesc: 'Birsortu erreserba baten faktura eta bidaialariaren gastu-oharra (kontularitza erabilgarria).',
    regenDone: 'Dokumentuak birsortu dira.',
    regenError: 'Ezin izan dira dokumentuak birsortu.',
    downloadError: 'Ezin izan da dokumentua deskargatu.',
    navInvoices: 'Fakturak',
    period30: 'Azken 30 egun',
    period90: 'Azken 90 egun',
    period365: 'Azken 12 hilabete',
    periodAll: 'Historial osoa',
    periodEmpty: 'Ez dago fakturarik epe honetan.',
    exportCsv: 'Esportatu CSV',
    exportZip: 'PDFak deskargatu (ZIP)',
    statusIssued: 'Argitaratuta',
    statusPaid: 'Ordainduta',
    statusVoid: 'Baliogabetuta',
  },
  owner: {
    calendar: {
      title: 'Tarifa-egutegia',
      subtitle: 'Prezioa, gutxieneko egonaldia eta eskuragarritasuna gautik gaura',
      navButton: 'Tarifak',
      backendRequired: 'Konfiguratu Supabase backend-a tarifa-egutegia erabiltzeko.',
      basePrice: 'Oinarrizko tarifa',
      cleaningFee: 'Garbiketa',
      applyTitle: 'Aplikatu hautapenari',
      clearSelection: 'Kendu hautapena',
      selectHint: 'Egin klik gau batean eta gero beste batean tartea aukeratzeko. Gelaxka bakoitza gau bat da: azkenekoa irteeraren aurreko gaua da.',
      selectedNights: 'Gau {{count}} hautatuta',
      skipped: 'Gau {{count}} saltatuta (erreserbatuta edo igarota)',
      noneEditable: 'Hautatutako gau guztiak erreserbatuta daude edo igaro dira.',
      priceLabel: 'Prezio berria (€)',
      pricePlaceholder: '€ / gau',
      minNightsLabel: 'Gutxieneko egonaldia (gauak)',
      minNightsPlaceholder: 'adib. 5',
      applyPrice: 'Ezarri prezioa',
      applyMinNights: 'Ezarri gutxienekoa',
      block: 'Blokeatu',
      unblock: 'Ireki',
      removeOverride: 'Kendu pertsonalizazioa',
      blockNameLabel: 'Blokearen izena',
      blockNamePlaceholder: 'adib. Mantentze-lana, Obra…',
      saved: 'Egutegia eguneratuta',
      saveError: 'Ezin izan da egutegia gorde.',
      legend: {
        available: 'Eskuragarri',
        priced: 'Prezio pertsonalizatua',
        blocked: 'Blokeatuta',
        booked: 'Erreserbatuta',
        past: 'Igarota',
        sunday: 'Igandea',
      },
      ical: {
        title: 'Esportatu egutegia (iCal)',
        desc: 'Lotu feed hau Airbnb, Booking.com edo zure channel manager-ekin erreserbak sinkronizatzeko.',
        copy: 'Kopiatu',
        copied: 'Esteka kopiatuta',
        unavailable: 'Feed hau ez dago erabilgarri propietate honetarako.',
      },
      bulk: {
        from: 'Nongo',
        to: 'nora',
        allDays: 'Egun guztiak',
        weekdays: 'Aste erdia',
        weekends: 'Asteburua',
        allYear: 'Urte osoa',
        pickDay: 'Aukeratu gutxienez asteko egun bat',
      },
    },
    revenueTitle: 'Sarrerak',
    invoicesTitle: 'Fakturak eta kobrantzak',
    invoicesNote: 'Fakturak automatikoki sortzen dira erreserba berrestean; ordainketak bitutravel-en egutegiaren arabera likidatzen dira.',
    gross: 'Oinarria (BEZ gabe)',
    fee: 'bitutravel komisioa',
    iva: 'BEZ',
    net: 'Sarrera garbiak',
    paidOut: 'Ordainduta',
    pending: 'Ordainketaren zain',
    monthlyTitle: 'Sarrerak hilabeteka',
    perPropertyTitle: 'Jabetzaren arabera',
    property: 'Jabetza',
    bookings: 'Erreserbak',
    nights: 'Gauak',
    payoutsTitle: 'Jabearen ordainketak',
    eligibleDesc: 'Ordaintzeko prest dauden erreserba berretsia:',
    payNow: 'Ordaindu',
    scheduled: 'Programatuta',
    noPayouts: 'Oraindik ez dago ordainketarik.',
    noData: 'Oraindik ez dago daturik.',
    payoutDone: 'Ordainketa egin da.',
    payoutError: 'Ezin izan da ordainketa egin.',
    range7: '7 eg',
    range15: '15 eg',
    range30: '30 eg',
    range90: '90 eg',
    range12m: '12 hb',
    rangeAll: 'Dena',
    payoutConfirmTitle: 'Berretsi ordainketa',
    payoutConfirmDesc: '#{{id}} erreserbaren {{amount}} ordainketa egin?',
    confirm: 'Berretsi',
    propertiesNav: 'Egutegia',
    propertiesTitle: 'Egutegia',
    newProperty: 'Gehitu jabetza',
    editProperty: 'Editatu',
    propertyUntitled: 'Izenik gabeko jabetza',
    propertiesEmpty: 'Oraindik ez duzu jabetzarik argitaratu.',
    pendingReviewNote: 'Jabetza berriak bitutravel taldeak onartu arte berrikuspeneko egonen dira. Posta bidez abisatuko zaitugu.',
    pendingEditorNote: 'Jabetza hau berrikuspeneko dago. Editatu ahalko duzu; onartutakoan bilaketan agertuko da.',
    unpublished: 'Argitaratu gabe',
    photoCount: '{{count}} argazki',
    noPhotos: 'Argazkirik ez',
    unitCount: '{{count}} unitate',
    viewCalendar: 'Egutegia',
    viewList: 'Zerrenda',
    searchUnits: 'Bilatu unitateak…',
    sortName: 'Izena',
    sortRecent: 'Azkenak',
    chipNeedsPhotos: 'Argazkirik ez',
    stripNoBookings: 'Erreserbarik ez hurrengo 30 egunetan',
    pms: {
      title: 'Erreserba-kudeatzailea',
      subtitle: 'Erreserbak unitateko — arrastatu lekuz aldatzeko',
      prev: 'Aurrekoa',
      next: 'Hurrengoa',
      today: 'Gaur',
      view_month: 'Hilabetea',
      view_week: 'Astea',
      dragHint: 'Arrastatu erreserba bat beste unitate edo datara lekuz aldatzeko.',
      moved: 'Erreserba lekuz aldatuta',
      moveError: 'Ezin izan da erreserba lekuz aldatu',
      noCity: 'Hiririk ez',
      cities: 'Hiriak',
      properties: 'Propietateak',
      unit: 'Unitatea',
      overall: 'Ikuspegi orokorra',
      allProperties: 'Propietate guztiak',
      noUnits: 'Ez daukazu unitaterik oraindik. Gehitu propietate bat hasteko.',
      guest: 'Ostatua',
      dragHintBlocked: "Haz clic en un día vacío para bloquearlo / abrirlo. Arrastra una reserva para moverla; arrastra su borde derecho para ampliar o acortar.",
      addBooking: "Añadir reserva",
      dates: 'Datak',
      autoRate: 'Tarifa automatikoa',
      applyCustomPrice: 'Aplikatu prezio pertsonalizatua (deskontua)',
      customPriceHint: 'Editatu totala deskontu bat aplikatzeko. Gauen artean banatzen da.',
      manualBooking: "Reserva manual",
      manualBadge: "Manual",
      guestName: "Nombre del huésped",
      guestNif: "NIF del huésped",
      guests: "Huéspedes",
      pricePerNight: "Gaueko prezioa",
      checkin: "Entrada",
      checkout: "Salida",
      block: "Bloquear",
      unblock: "Abrir",
      blocked: "Bloqueado",
      blockTitle: 'Blokeatu gaua',
      blockNameLabel: 'Izena (aukerakoa)',
      blockNamePlaceholder: 'adib. Mantentze-lana',
      blockNameHint: 'Blokeatutako egunean erakutsiko da.',
      blockConfirm: 'Blokeatu',
      manualCreated: "Reserva manual creada",
      manualError: "No se pudo crear la reserva manual",
      notAvailable: "No disponible para esas fechas",
      belowMinStay: "Por debajo de la estancia mínima de esta unidad",
      detail: "Detalle de la reserva",
      property: "Propiedad",
      nights: "Noches",
      total: "Total",
      iva: "IVA",
      fee: "Comisión de la plataforma",
      payout: "Pago",
      channel: "Canal",
      status: "Estado",
      statusConfirmed: "Confirmada",
      statusActive: "En estancia",
      statusPending: "Pendiente",
      statusAwaiting: "Pendiente de pago",
      statusCancelled: "Cancelada",
      channelManual: "Manual",
      channelDirect: "Directo",
      channelIcal: "iCal (inportatua)",
      icalNoPayout: "Blokeo kanpotarra — ordainik gabe",
      confirmMove: "Confirmar movimiento",
      moveFrom: "Desde",
      moveTo: "Hasta",
      moveNote: "La disponibilidad y el precio se revalidan al confirmar.",
      confirm: "Confirmar",
      extendTitle: "Ampliar estancia",
      shortenTitle: "Acortar estancia",
      newCheckout: "Nueva salida",
      extended: "Estancia actualizada",
      extendError: "No se pudo actualizar la estancia",
    },
    products: {
      nav: 'Jabetzak',
      title: 'Jabetzak',
      subtitle: 'Tarifak eta kanalak unitateko. Tarifa lehenetsia propietatearen prezioarekin sinkronizatzen da.',
      empty: 'Ez duzu propietaterik oraindik.',
      ratePlans: 'Tarifak',
      addRatePlan: 'Gehitu tarifa',
      editRatePlan: 'Editatu tarifa',
      ratePlanDesc: 'Tarifa bat unitate honen eskaintza salgarria da (prezioa, garbiketa, gutxieneko egonaldia).',
      noPlans: 'Tarifarik ez oraindik.',
      planCount: '{{count}} tarifa',
      icalCount: '{{count}} iCal',
      default: 'Lehenetsia',
      inactive: 'Inaktiboa',
      minNights: 'gutx. {{count}} gau',
      minNightsLabel: 'Gutxieneko gauak',
      feePct: '{{pct}}% komisioa',
      feePctLabel: 'bitutravel komisioa (%)',
      feePctPlaceholder: 'lehenetsia',
      feePctHint: 'Hutsik = komisio orokorra. 0 = bezero propioa (komisiorik gabe).',
      makeDefault: 'Tarifa lehenetsia',
      name: 'Izena',
      basePrice: 'Oinarrizko prezioa (NET)',
      cleaningFee: 'Garbiketa',
      cancellation: 'Baldintzak',
      policy: {
        flexible: 'Malgua',
        moderate: 'Moderatua',
        strict: 'Zorrotza',
      },
      save: 'Gorde',
      cancel: 'Utzi',
      edit: 'Editatu',
      delete: 'Ezabatu',
      confirmDelete: 'Ezabatu?',
      defaultNoDelete: 'Ezin da tarifa lehenetsia ezabatu.',
      created: 'Tarifa sortuta.',
      updated: 'Tarifa eguneratuta.',
      deleted: 'Tarifa ezabatuta.',
      channels: 'Kanalak',
      addChannel: 'Gehitu kanala',
      direct: 'Zuzena',
      noConnections: 'Konexiorik ez. Gehitu iCal kanal bat kanpoko egutegia inportatzeko.',
      icalChannel: 'iCal',
      addIcal: 'Gehitu iCal konexioa',
      icalDesc: 'Itsatsi kanpoko egutegi baten iCal URLa (Airbnb, Booking, Google…). Erreserbatutako datek unitate hau blokeatuko dute.',
      icalUrl: 'Egutegiaren iCal URLa',
      addAndSync: 'Gehitu eta sinkronizatu',
      syncNow: 'Sinkronizatu',
      syncAll: 'Dena sinkronizatu',
      syncDone: '{{upserted}} inportatuta, {{cancelled}} bertan behera, {{conflicts}} gatazka',
      syncAllDone: 'Sinkronizazio osoa: {{upserted}} inportatuta, {{cancelled}} bertan behera, {{conflicts}} gatazka',
      syncError: 'Sinkronizazio errorea',
      lastSync: 'Azken sinkronizazioa',
      neverSynced: 'Oraindik sinkronizatu gabe',
      connectionDeleted: 'Konexioa ezabatuta.',
      connStatus: {
        pending: 'Zain',
        active: 'Aktiboa',
        paused: 'Pausatuta',
        error: 'Errorea',
      },
      rangeActionTitle: 'Hautatutako tartea',
      rangeActionHint: 'Zer egin nahi duzu gau hauekin?',
      selectHint: 'Egin klik gau batean eta gero bestean (edo birritan berean) tarte bat hautatzeko.',
    },

    status: {
      pending: 'Berrikuspeneko',
      approved: 'Argitaratua',
      rejected: 'Baztertuta',
    },
    step1: 'Datuak',
    step2: 'Deskribapena',
    step3: 'Kokapena eta argazkiak',
    backStep: 'Atzera',
    nextStep: 'Hurrengoa',
    saveProperty: 'Gorde jabetza',
    fieldType: 'Ostatu mota',
    type: {
      apartment: 'Apartamentua',
      studio: 'Estudioa',
      house: 'Etxea',
      room: 'Logela',
      loft: 'Loft',
      duplex: 'Duplex',
      cabin: 'Etxola',
      guesthouse: 'Ostatu-etxea',
      hotel: 'Hotela',
      bed_breakfast: 'Ostatua eta gosaria',
    },
    fieldCapacity: 'Edukiera (pertsonak)',
    fieldBeds: 'Oheak',
    fieldPrice: 'Prezia gauero (€)',
    fieldCleaning: 'Garbiketa-tarifa (€)',
    fieldCheckinTime: 'Sarreraren ordua',
    fieldCheckoutTime: 'Irteeraren ordua',
    fieldTitleEs: 'Izenburua (gaztelaniaz)',
    fieldTitleEn: 'Izenburua (ingelesez)',
    fieldDescEs: 'Deskribapena (gaztelaniaz)',
    fieldDescEn: 'Deskribapena (ingelesez)',
    fieldCity: 'Hiria',
    fieldCategory: 'Kategoria',
    fieldCategoryHint: 'exekutibo, estandar, suite…',
    fieldBuilding: 'Eraikina / helbidea',
    fieldUnitLabel: 'Unitate-etiketa',
    fieldNeighborhood: 'Auzoa / barrutia',
    fieldNeighborhoodHint: 'adib. Chamberí',
    fieldPostalCode: 'Posta-kodea',
    cityPrefillNote: 'Hiria aukeratzean koordenatuak hiriaren erdigunearekin betetzen ditugu; doit itzazu kokapen zehatza badakizu.',
    photosAfterCreate: 'Gorde jabetza argazkiak gehitzeko.',
    addPhotos: 'Gehitu argazkiak',
    deletePhoto: 'Ezabatu argazkia',
    photoUploadError: 'Ezin izan da argazkia igo.',
    photoDeleteError: 'Ezin izan da argazkia ezabatu.',
    createdToast: 'Jabetza sortu da. Berrikuspeneko dago.',
    savedToast: 'Jabetza gorde da.',
    saveError: 'Ezin izan da jabetza gorde.',
    fiscal: {
      title: 'Datu fiskalak eta VeriFactu',
      subtitle: 'Igorlearen datuak eta bitutravel-ek zure fakturak AEATera bidaltzeko baimena.',
      statusActive: 'VeriFactu aktibo. Zure ostatu-fakturak AEATera bidaltzen dira.',
      statusPending: 'VeriFactu zain. Zure fakturak jaulkitzen dira baina EZ dira AEATera bidaltzen.',
      statusRevoked: 'Zure baimena indargabetu da. AEATera bidaltzea pausatuta dago.',
      active: 'Aktibo',
      pending: 'Zain',
      revoked: 'Indargabetuta',
      issuerTitle: 'Igorlearen datuak',
      personaType: 'Pertsona mota',
      personaF: 'Fisikoa',
      personaJ: 'Juridikoa',
      seriesLodging: 'Faktura-seriea',
      seriesHint: 'Zure ostatu-fakturentzako AEAT seriea (lehenetsia O). Ez aldatu arrazoirik gabe.',
      legalName: 'Izen soziala / Izena',
      nif: 'NIF',
      country: 'Herrialdea',
      street: 'Helbidea',
      postalCode: 'Posta-kodea',
      city: 'Herria',
      save: 'Gorde datu fiskalak',
      saved: 'Datu fiskalak gordeta.',
      saveError: 'Ezin izan dira datu fiskalak gorde.',
      errFields: 'Izen soziala eta NIF nahitaezkoak dira.',
      apoderamientoTitle: 'Ordezkaritza',
      apoderamientoDesc: 'Zure izenean fakturak AEATera bidaltzeko, bitutravel-ek ordezkaritza-agiri sinatua behar du. Igo agiri sinatua bidalketa aktibatzeko.',
      poderOnFile: 'Erregistratutako agiria:',
      uploadPoder: 'Igo agiri sinatua (PDF)',
      poderHint: 'PDF, geh. 10 MB.',
      granted: 'Ordezkaritza aktibatuta. VeriFactu-ek zure hurrengo fakturak bidaliko ditu.',
      grantError: 'Ezin izan da agiria erregistratu.',
      errPoderSize: 'Fitxategiak 10 MB gainditzen ditu.',
      legalNote: 'Agiria igotzean baieztatzen duzula ordezkaritza-baimena sinatu duzula bitutravel-ek fakturak AEATera bidaltzeko (RD 1007/2023).',
      bannerPending: 'Aktibatu VeriFactu zure fakturak AEATera bidaltzeko.',
      bannerRevoked: 'Zure VeriFactu baimena indargabetuta dago.',
      bannerCta: 'Konfiguratu',
    },

  },
  profile: {
    title: 'Profila eta ezarpenak',
    navProfile: 'Profila',
    accountSection: 'Kontua',
    statusLabel: 'Kontuaren egoera',
    rejectionReason: 'Baztertzearen arrazoia',
    detailsSection: 'Zerga-datuak',
    languageSection: 'Hizkuntza',
    localeLabel: 'Hobetsitako hizkuntza',
    localeHint: 'Zure kontuan gordetzen da eta zure gailu guztietan aplikatzen da.',
    localeSaved: 'Hizkuntza eguneratu da.',
    billingSection: 'Fakturazioa eta ordainketa',
    invoiceEmail: 'Fakturazio-emaila',
    invoiceEmailPlaceholder: 'fakturak@zurenagusia.eus',
    ibanTransfer: 'IBAN (transferentziaz ordaintzeko)',
    ibanHint: 'Transferentzia bankarioz ordaintzea nahi baduzu.',
    preferredMethod: 'Ordainketa-methodo hobetsia',
    methodCard: 'Txartela',
    methodTransfer: 'Transferentzia',
    savedCards: 'Gordetako txartelak',
    defaultCard: 'Lehenetsia',
    billingProcessorNote: 'Txartel-datuak Revolutekin tokenizatzen dira; ez dugu inoiz zenbaki osoa gordeko.',
    billingSaved: 'Fakturazioa eguneratuta.',
  },
  auth: {
    registerTitle: 'Kontua sortu',
    loginTitle: 'Saioa hasi',
    rolePrompt: 'Nola erabiliko duzu bitutravel?',
    roleBook: 'Ostatuak erreserbatzen ditut',
    roleList: 'Jabetzak argitaratzen ditut',
    roleCompany: 'Enpresa',
    roleAutonomo: 'Autonomoa',
    roleOwner: 'Jabea',
    roleEmployeeLabel: 'Langilea',
    roleAgencyLabel: 'Agentzia',
    roleCompanyDesc: 'Erreserba zentralizatuak zure enpresarentzat',
    roleAutonomoDesc: 'Autonomo profesionalentzat',
    roleOwnerDesc: 'Argitaratu eta monetizatu zure jabetzak',
    roleBookerPrompt: 'Nork erreserbatzen du?',
    pathManager: 'Propietateak kudeatzen ditut',
    pathManagerDesc: 'Zure inbentarioa argitaratu eta tarifak eta disponibilitatea kudeatu',
    pathBook: 'Egonaldiak erreserbatzen ditut',
    pathBookDesc: 'Enpresetzat, langileentzat eta autonomoentzat',
    roleEmployee: 'Enpresa batean lan egiten dut',
    roleEmployeeDesc: 'Nire enpresaren txartelarekin erreserbatzen dut; faktura berarentzat da',
    contactName: 'Harreman-pertsona',
    email: 'Helbide elektronikoa',
    fullName: 'Izen osoa',
    legalName: 'Izen soziala',
    cif: 'CIF',
    nif: 'NIF / DNI',
    address: 'Helbidea',
    iban: 'Kobrantzarako IBAN',
    irpf: 'IRPF atxikipena (%)',
    submit: 'Eskaera bidali',
    pendingTitle: 'Eskaera berrikuspenean',
    pendingDesc: 'Gure taldea zure kontua egiaztatzen ari da. Onartutakoan posta bidez abisatuko zaitugu.',
    pendingApproved: 'Zure kontua onartu da!',
    checkStatus: 'Berriro egiaztatu',
    profileErrorTitle: 'Ezin izan dugu zure profila kargatu',
    profileErrorDesc:
      'Zure saioa baliozkoa da, baina ez dugu aurkitu zure kontuaren datuak. Saiatu berriro edo itzali saioa.',
    rejectedTitle: 'Eskaera baztertua',
    rejectedDesc: 'Zure eskaera ez da onartu. Arrazoia: {{reason}}',
    loginPrompt: 'Baduzu kontua? Hasi saioa',
    registerPrompt: 'Ez baduzu konturik? Eman izena',
    login: 'Saioa hasi',
    magicLink: 'Esteka magikoa bidali',
    magicLinkSent:
      'Esteka magiko bat bidali dizugu zure postara. Ireki ezazu saioa hasteko.',
    cifInvalid: 'CIF baliogabea',
    cifInRegistry: 'Direktorioan aurkitua',
    nifOrCifInvalid: 'NIF/CIF baliogabea',
    ibanInvalid: 'IBAN baliogabea',
    irpfRange: '7 eta 45 % artean egon behar du',
    loginErrorGeneric: 'Ezin izan da saioa hasi. Egiaztatu posta helbidea.',
    loginRateLimited: 'Saiakera gehiegi. Itxaron minutu bat.',
    loginEmailNotConfirmed: 'Berretsi zure posta helbidea saioa hasi aurretik.',
  },
  admin: {
    approvalsTitle: 'Onarpen-ilara',
    approve: 'Onartu',
    reject: 'Baztertu',
    reason: 'Arrazoia',
    empty: 'Ez dago eskaerarik zain',
    typeCompany: 'Enpresa',
    typeAutonomo: 'Autonomoa',
    typeOwner: 'Jabea',
    approvedToast: 'Eskaera onartu da',
    rejectedToast: 'Eskaera baztertu da',
    decisionFailed: 'Ezin izan da erabakia gorde',
    searchPlaceholder: 'Bilatu izen, posta edo NIF/CIF arabera',
    tabAll: 'Denak',
    tabCompany: 'Enpresak',
    tabAutonomo: 'Autonomoak',
    tabOwner: 'Jabeak',
    confirmApprove: '{{name}} onartu?',
    confirmReject: '{{name}} baztertu?',
    confirm: 'Berretsi',
    reasonRequired: 'Adierazi baztertzearen arrazoia',
    noMatches: 'Emaitzarik ez',
    roleAdmin: 'Administrazioa',
    consoleTitle: 'Administrazio-kontsola',
    navApprovals: 'Onespenak',
    navAccounts: 'Kontuak',
    navBookings: 'Erreserbak',
    navInvoices: 'Fakturak',
    tabAgency: 'Agentziak',
    tabEmployee: 'Langileak',
    tabBlocked: 'Blokeatuta',
    typeAgency: 'Agentzia',
    typeEmployee: 'Langilea',
    typeAdmin: 'Administratzailea',
    typeSuperadmin: 'Superadmin',
    statusPending: 'Zain',
    active: 'Aktibo',
    blocked: 'Blokeatuta',
    rejected: 'Baztertuta',
    block: 'Blokeatu',
    unblock: 'Desblokeatu',
    blockedToast: 'Kontua blokeatuta',
    unblockedToast: 'Kontua desblokeatuta',
    manageFailed: 'Ezin izan da kontuaren egoera aldatu',
    commissionDefault: 'Lehenetsia {{pct}}%',
    commissionEdit: 'Editatu',
    commissionSave: 'Gorde',
    commissionCancel: 'Utzi',
    commissionSaved: 'Komisioa eguneratuta.',
    commissionFailed: 'Ezin izan da komisioa eguneratu.',
    lastActions: '{{count}} administrazio-ekintza erregistratuta',
    noBookings: 'Ez dago erreserbarik.',
    noInvoices: 'Ez dago fakturarik.',
    kindCommission: 'Komisioa',
    kindLodging: 'Ostatua',
    vfFiled: 'VeriFactu bidalita',
    vfIncidence: 'Gertakaria',
    vfPending: 'VeriFactu zain',
    navRegistry: 'Direktorioa',
    vfSubmit: 'AEATri bidali',
    vfSubmitted: 'AEATri bidalita',
    vfSubmitFailed: 'Ezin izan da AEATri bidali',
    vfNotConfigured: 'VeriFactu ziurtagiria konfiguratu gabe',
    void: 'Baliogabetu',
    voidConfirm: 'Faktura hau baliogabetu? AEATri bidalia izan bada, baliogabetze bat bidaliko da.',
    voidDone: 'Faktura baliogabetuta',
    voidFailed: 'Ezin izan da faktura baliogabetu',
    voidAnulacionPending: 'AEAT baliogabetzea ziurtagiriaren zain',
    voided: 'Baliogabetuta',
    rect: 'Zuzenketa',
    rectConfirm: 'Faktura hau ordezkatuko duen zuzenketa bat igarri?',
    rectDone: 'Zuzenketa ilarria',
    rectFailed: 'Ezin izan da zuzenketa ilarri',
    registry: {
      addTitle: 'Enpresa gehitu',
      editTitle: 'Enpresa editatu',
      listTitle: 'Enpresa direktorioa',
      cif: 'CIF',
      legalName: 'Izen soziala',
      street: 'Kalea',
      postalCode: 'Posta kodea',
      city: 'Hiria',
      province: 'Probintzia',
      country: 'Herrialdea',
      save: 'Gorde',
      saved: 'Enpresa gordeta',
      saveError: 'Ezin izan da enpresa gorde',
      deleted: 'Enpresa ezabatuta',
      deleteError: 'Ezin izan da enpresa ezabatu',
      errFields: 'CIF eta izen soziala nahitaezkoak dira',
      empty: 'Oraindik ez dago enpresarik direktorioan',
      edit: 'Editatu',
    },
  },
  dashboard: {
    roleLabel: 'Rola',
    emailLabel: 'Posta',
  },
  notFound: {
    title: 'Orria ez da aurkitu',
    desc: 'Bilatzen duzun orria ez da existitzen edo helbidea aldatu du.',
  },
  error: {
    boundaryDesc: 'Zerbait gaizki joan da. Kargatu berriro jarraitzeko.',
    boundaryReload: 'Birkargatu',
  },
  common: {
    loading: 'Kargatzen…',
    error: 'Zerbait gaizki atera da',
    favorite: 'Gorde gogokoenetan',
    required: 'Derrigorrezkoa',
    back: 'Itzuli',
    retry: 'Saiatu berriro',
    continue: 'Jarraitu',
    done: 'Eginda',
    save: 'Gorde',
    plusIva: '+ BEZ',
    cancel: 'Utzi',
    rooms: 'logela',
    room: 'logela',
    bathrooms: 'bainu',
    bathroom: 'bainu',
    increment: 'Handitu',
    decrement: 'Txikitu',
    edit: 'Editatu',
    close: "Itxi",
    previous: 'Aurrekoa',
    next: 'Hurrengoa',
  },
  amenities: {
    wifi: 'Wifi',
    parking: 'Aparkalekua',
    ac: 'Aire girotua',
    heating: 'Beroketa',
    washing: 'Garbailua',
    dishwasher: 'Plater-garbailua',
    elevator: 'Igogailua',
    furnished: 'Moblatua',
    kitchen: 'Sukaldea',
    meeting_room: 'Bilera-gela',
    printer: 'Inprimagailua',
    gym: 'Gimnasioa',
  },
} as const